import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const DefaultDocumentHead = () => {
  const { t } = useTranslation();
  const title = t('brand');

  return <Helmet defaultTitle={title}><title>{title}</title></Helmet>;
};

export default DefaultDocumentHead;
